import { render, staticRenderFns } from "./AddContactsToStaticList.vue?vue&type=template&id=5e4c4ea5&lang=pug"
import script from "./AddContactsToStaticList.vue?vue&type=script&lang=js"
export * from "./AddContactsToStaticList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports